/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface HookSchema
 */
export interface HookSchema {
  /**
   *
   * @type {string}
   * @memberof HookSchema
   */
  status: string;
}

/**
 * Check if a given object implements the HookSchema interface.
 */
export function instanceOfHookSchema(value: object): value is HookSchema {
  if (!('status' in value) || value['status'] === undefined) return false;
  return true;
}

export function HookSchemaFromJSON(json: any): HookSchema {
  return HookSchemaFromJSONTyped(json, false);
}

export function HookSchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HookSchema {
  if (json == null) {
    return json;
  }
  return {
    status: json['status'],
  };
}

export function HookSchemaToJSON(value?: HookSchema | null): any {
  if (value == null) {
    return value;
  }
  return {
    status: value['status'],
  };
}
